import styled from '@emotion/styled';
import type { MicrositeProfile } from '~/model';
import BetaAgentList from '~/editor/templates/beta/lib/BetaAgentList';
import MicrositeSection from '~/components/MicrositeSection';

const Inner = styled.div`
	margin: 0 auto;
	max-width: 64rem;
`;

export default function ProfileBlockBeta({ profiles }: { profiles: MicrositeProfile[] }) {
	if (profiles.length === 0) {
		return null;
	}

	return (
		<MicrositeSection padding>
			<Inner>
				<BetaAgentList profiles={profiles} />
			</Inner>
		</MicrositeSection>
	);
}
